import axios from 'axios';
import cookies from '../utils/cookies';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(process.env.REACT_APP_DEV_API_KEY && {
      'x-api-key': process.env.REACT_APP_DEV_API_KEY,
    }),
  },
});

instance.interceptors.request.use(function (config) {
  const storedToken = cookies.get('accessToken');
  const mergedHeaders = {
    ...config.headers,
  };

  if (storedToken) {
    mergedHeaders.Authorization = `Bearer ${storedToken}`;
  }

  return {
    ...config,
    headers: mergedHeaders,
  };
});

export default instance;
